import React from "react";
import { Card } from "../../components/ui/card";
import Seo from "../../components/Seo";

const SECTIONS = [
  {
    title: "1. Non-Fiduciary Utility Scope",
    body: "COMMITMENTT is an organisational and visibility utility — an Income Shield that helps you see your Commitment Position and Safe-to-Spend estimates. It is not a bank, lender, broker, or financial adviser, and nothing it shows constitutes financial, tax, or investment advice.",
  },
  {
    title: "2. User Responsibility for Commitment Inputs",
    body: "You are responsible for the accuracy of the income and commitment information you enter and confirm. Figures such as Commitment Ratio and Safe-to-Spend are estimates derived directly from your inputs, and their usefulness depends on those inputs being correct and up to date.",
  },
  {
    title: "3. Service Availability & Read-Only Guarantees",
    body: "COMMITMENTT is a read-only service with zero capability to move or transfer funds and no requirement for bank credentials. As an evolving product, features may change, pause, or be withdrawn, and availability is provided on a best-effort basis without warranty of uninterrupted service.",
  },
  {
    title: "4. Your Data",
    body: "Your data is handled as described in our Privacy Policy. You own your information and may export or permanently delete it at any time, with one-click erasure available from your profile.",
  },
];

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-5 py-14">
      <Seo title="Terms of Service" description="COMMITMENTT terms of service — a read-only, non-fiduciary Income Shield utility. Not a bank and not financial advice." />
      <span className="text-xs tracking-[0.2em] uppercase font-semibold text-mint">Terms of Service</span>
      <h1 className="font-heading text-4xl font-light text-navy mt-3">Terms of use</h1>
      <p className="text-slatey mt-4 leading-relaxed">
        These terms explain what COMMITMENTT is — and is not — and the basis on which you use it.
      </p>

      <div className="space-y-4 mt-8">
        {SECTIONS.map((s) => (
          <Card key={s.title} className="rounded-2xl border-border shadow-card-sm p-6" data-testid={`terms-section-${s.title.split(".")[0]}`}>
            <h3 className="font-heading text-lg font-medium text-navy">{s.title}</h3>
            <p className="text-sm text-slatey mt-2 leading-relaxed">{s.body}</p>
          </Card>
        ))}
      </div>

      <div className="rounded-2xl bg-secondary/70 border border-border p-5 mt-6">
        <p className="text-sm text-muted-foreground">
          <strong className="text-ink">Plain-language summary.</strong> This is a plain-language overview of our terms, not formal legal advice.
          Please review and adapt it with a qualified professional before relying on it for a production launch.
        </p>
      </div>
    </div>
  );
}
